import useSWR from 'swr'
import type { ShortlistRound } from 'views/ProjectsV2/Shortlist/types'

const extractList = (body: any): ShortlistRound[] => {
  if (Array.isArray(body)) return body
  if (Array.isArray(body?.data)) return body.data
  if (Array.isArray(body?.rounds)) return body.rounds
  if (Array.isArray(body?.data?.rounds)) return body.data.rounds
  return []
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include' }).then(async (res) => {
    if (!res.ok) {
      const text = await res.text()
      throw new Error(`GET failed: ${res.status} ${text}`)
    }
    const body = await res.json()
    return extractList(body)
  })

const useShortlistRounds = (dealId: string | null) => {
  const key = dealId
    ? `${process.env.REACT_APP_BACKEND_URL}/api/v2/admin/deals/${dealId}/shortlist/rounds`
    : null

  const { data, error, isLoading, mutate } = useSWR<ShortlistRound[]>(
    key,
    fetcher,
    { refreshInterval: 30000 },
  )

  return {
    rounds: Array.isArray(data) ? data : [],
    isLoading,
    isError: error,
    mutate,
  }
}

export default useShortlistRounds
